import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'relaxMenuItemHeightConsistency',
  initialState: false,
  reducers: {
    setRelaxMenuItemHeightConsistency(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setRelaxMenuItemHeightConsistency } = slice.actions;

export default slice.reducer;
